import {
  i
} from "./chunk.FAJKIEWS.js";

// src/components/jb-time/jb-time.css.ts
var jb_time_css_default = i`time{font-family:var(--theme-font-light-family, VerlagSSm, Tahoma, sans-serif);font-style:normal;font-weight:var(--theme-font-light-weight, 300)}time{font-size:var(--theme-typo-p-mini-desktop-fontsize, 0.813rem);line-height:var(--theme-typo-p-mini-desktop-lineheight, 1.25rem)}:host{--jb-clock-opacity: 1}time{align-items:center;color:#141e55;display:flex}time jb-clock-icon{display:inline-flex;margin-right:var(--theme-spacing-base);padding:5px;width:26px}`;

export {
  jb_time_css_default
};
